import { c as _c } from "react/compiler-runtime";
import { Form, Formik } from 'formik';
import { useContext } from 'react';
import { isFreePlan } from '../../../../../utils/subscription';
import Button from '../../../../common/base/Button';
import Container from '../../../../common/base/Container';
import Divider from '../../../../common/base/Divider';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import CopyableField from '../../../../common/CopyableField';
import { useDialog } from '../../../../common/Dialog';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
import OrganizationSecurity from './OrganizationSecurity';
const OrganizationSettings: React.FC = () => {
  const $ = _c(46);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    organization,
    organization_role,
    mutateOrganization,
    subscription,
    resetContext
  } = useContext(DashboardContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  let t0;
  if ($[0] !== HookdeckAPI.organizations || $[1] !== addToast || $[2] !== mutateOrganization) {
    t0 = values => HookdeckAPI.organizations.update(values).then(organization_0 => {
      addToast("success", "Organization updated");
      mutateOrganization(organization_0);
      return true;
    }).catch(() => {
      addToast("error", "Failed to update organization");
    });
    $[0] = HookdeckAPI.organizations;
    $[1] = addToast;
    $[2] = mutateOrganization;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleSubmit = t0;
  let t1;
  if ($[4] !== HookdeckAPI.organizations || $[5] !== addToast || $[6] !== organization.name || $[7] !== resetContext || $[8] !== showDialog) {
    t1 = () => showDialog(() => HookdeckAPI.organizations.delete().then(() => {
      resetContext();
    }).catch(() => {
      addToast("error", "The organization could not be deleted, please contact us.");
    }), undefined, {
      title: "Delete organization",
      submit_label: "Delete organization",
      cancel_label: "Cancel",
      submit_icon: "delete",
      danger: true,
      form_props: {
        initial_values: {
          name: ""
        },
        validate: t2 => {
          const {
            name
          } = t2;
          if (!name || name.length < 0) {
            return {
              name: "Required"
            };
          }
          if (name !== organization.name) {
            return {
              name: "Organization name does not match."
            };
          }
          return {};
        },
        Fields: () => <><Text m={{
            b: 4
          }}>This action can’t be undone. You’ll lose all of the billing history, the projects within this organization and their associated data. Are you sure? <br /><br />If you’d like to delete this organization, type{" "}<strong>{organization.name}</strong> below to confirm.</Text><TextInput m={0} name="name" placeholder={organization.name} required={true} /></>
      }
    });
    $[4] = HookdeckAPI.organizations;
    $[5] = addToast;
    $[6] = organization.name;
    $[7] = resetContext;
    $[8] = showDialog;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const onDelete = t1;
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      b: 10
    };
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== organization.name) {
    t3 = {
      name: organization.name
    };
    $[11] = organization.name;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== organization.name) {
    t4 = props => <Form><Text bold={true} size="l" as="h2" m={{
        t: 0,
        b: 4
      }}>Organization name</Text><TextInput name="name" required={true} m={{
        b: 5
      }} /><Button.Permission primary={true} disabled={!props.isValid || !props.touched || props.isSubmitting || organization.name === props.values.name} submit={true} icon={props.isSubmitting ? "loading" : "save"}>Save</Button.Permission></Form>;
    $[13] = organization.name;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== handleSubmit || $[16] !== t3 || $[17] !== t4) {
    t5 = <Div m={t2}><Formik initialValues={t3} validate={_temp} onSubmit={handleSubmit}>{t4}</Formik></Div>;
    $[15] = handleSubmit;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      b: 10
    };
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Text bold={true} size="l" as="h2" m={{
      t: 0,
      b: 4
    }}>Organization ID</Text>;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== organization.id) {
    t8 = <Div m={t6}>{t7}<CopyableField mono={true} value={organization.id} /></Div>;
    $[21] = organization.id;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t8) {
    t9 = <Container medium={true} left={true}>{t5}{t8}</Container>;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Div m={{
      y: 10
    }}><OrganizationSecurity /></Div>;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Div m={{
      x: 6,
      b: 8
    }}><Divider /></Div>;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      b: 10
    };
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Div m={{
      b: 4
    }}><Text bold={true} size="l" as="h2" m={0}>Delete organization</Text><Text muted={true}>Permanently delete this organization and all projects within it. The organization must be on the developer plan with no unpaid invoices in order to be deleted.</Text></Div>;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== organization_role || $[31] !== subscription) {
    t14 = organization_role === "owner" && isFreePlan(subscription.plan);
    $[30] = organization_role;
    $[31] = subscription;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const t15 = organization_role !== "owner" ? "Restricted to the organization owner" : !isFreePlan(subscription.plan) ? "Organization must be on the developer (free) plan" : "";
  let t16;
  if ($[33] !== organization_role || $[34] !== subscription) {
    t16 = organization_role !== "owner" || !isFreePlan(subscription.plan);
    $[33] = organization_role;
    $[34] = subscription;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== onDelete || $[37] !== t16) {
    t17 = <Button disabled={t16} danger={true} outline={true} icon="delete" onClick={onDelete}>Delete organization</Button>;
    $[36] = onDelete;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t14 || $[40] !== t15 || $[41] !== t17) {
    t18 = <Container medium={true} left={true}><Div m={t12}>{t13}<Tooltip disabled={t14} tooltip={t15}>{t17}</Tooltip></Div></Container>;
    $[39] = t14;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18 || $[44] !== t9) {
    t19 = <>{t9}{t10}{t11}{t18}</>;
    $[43] = t18;
    $[44] = t9;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
};
export default OrganizationSettings;
function _temp(values_0) {
  const errors = {};
  if (!values_0.name || values_0.name.length === 0) {
    errors.name = "Required";
  }
  if (values_0.name && values_0.name.length > 40) {
    errors.name = "Name is longer then 40 characters";
  }
  return errors;
}